<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${serviceCenter.name}` }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="serviceCenter" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "service-center-view-logs",

  components: { LogListTable },

  props: ["serviceCenter"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
